<template>
    <transition
        name="modal"
        appear
    >
        <div
            class="modal-mask"
            @click="clickOut"
        >
            <div class="d-table h-100 w-100">
                <div class="modal-wrapper">
                    <div
                        ref="container"
                        :class="classes"
                        class="modal-container"
                    >
                        <div
                            v-if="$slots.header"
                            class="modal-header"
                        >
                            <slot name="header" />
                        </div>

                        <div class="modal-body">
                            <slot name="body">
                                default body
                            </slot>
                        </div>

                        <div class="modal-footer">
                            <slot name="footer">
                                <button
                                    class="btn btn-success"
                                    @click="$emit('close')"
                                >
                                    OK
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "BaseModal",

        props: {
            classes: {type: String, default: ""}
        },

        methods: {
            /**
             * close quand un clique est réalisé ailleurs sur le document
             */
            clickOut: function (event) {
                if (event.target !== null && event.target.closest('.modal-container') !== this.$refs.container) {
                    this.$emit('close')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~sass/_variables";

    .modal-mask {
        position: fixed;
        z-index: 9997;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        overflow: auto;

        .modal-wrapper {
            display: table-cell;
            vertical-align: middle;
            padding: 20px 0;

            .modal-container {
                width: 800px;
                margin: 0 auto;
                background-color: #fff;
                border-radius: 2px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, .33);

                .modal-header {
                    border-radius: 0;
                    padding: 20px 30px;
                    background-color: $primary;
                    color: $white;
                }

                .modal-body {
                    padding: 20px 30px;
                }

                .modal-footer {
                    padding: 20px 30px;
                    border-top: none;
                }
            }
        }
    }
</style>
